module.exports = __webpack_public_path__ + "img/choose-up-gradinita-disabled.28664f85.png";